import type { StackFrame } from '@sentry/nextjs';

// Sentry's browserApiErrors wrapper frame lives in our chunk, so the throwing frame is what identifies Maps.
export function isGoogleMapsInternalCrash(
  mechanism: { type?: string; handled?: boolean } | undefined,
  frames: StackFrame[],
): boolean {
  return (
    mechanism?.handled === false &&
    (frames.at(-1)?.filename ?? frames.at(-1)?.abs_path ?? '').includes('/maps-api-v3/')
  );
}
